import PropTypes from 'prop-types';

export const productPT = PropTypes.exact({
  brand: PropTypes.exact({
    name: PropTypes.exact({
      contact_person: PropTypes.string,
      created_at: PropTypes.string,
      deleted_at: PropTypes.string,
      description: PropTypes.string,
      email: PropTypes.string,
      id: PropTypes.string,
      img_path: PropTypes.string,
      name: PropTypes.string,
      phone_number: PropTypes.string,
      picture: PropTypes.string,
      show_in_marketplace: PropTypes.bool,
      store_id: PropTypes.string,
      type_id: PropTypes.number,
      updated_at: PropTypes.string,
      uri_param: PropTypes.string,
    })
  }),
  categories: PropTypes.arrayOf(PropTypes.exact({
    description: PropTypes.string,
    id: PropTypes.string,
    milligram: PropTypes.bool,
    name: PropTypes.string,
    parent_id: PropTypes.string,
    uri_param: PropTypes.string,
  })),
  children: PropTypes.array,
  description: PropTypes.string,
  government_limit: PropTypes.number,
  id: PropTypes.string,
  instructions: PropTypes.string,
  is_bundle: PropTypes.bool,
  is_canabis: PropTypes.bool,
  is_staff_pick: PropTypes.bool,
  name: PropTypes.string,
  net_weight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  net_weight_g: PropTypes.string,
  parent_id: PropTypes.string,
  personalities: PropTypes.arrayOf(PropTypes.exact({
    id: PropTypes.string,
    name: PropTypes.string,
  })),
  pictures: PropTypes.arrayOf(PropTypes.string),
  productExists: PropTypes.bool,
  product_cbd: PropTypes.number,
  product_cbd_content: PropTypes.number,
  product_cbg: PropTypes.number,
  product_cbn: PropTypes.number,
  product_delta_8: PropTypes.number,
  product_delta_9: PropTypes.number,
  product_thc: PropTypes.number,
  product_thc_content: PropTypes.number,
  product_thca: PropTypes.number,
  product_type: PropTypes.string,
  product_type_name: PropTypes.string,
  quantity: PropTypes.string,
  sales_discount_percentage: PropTypes.number,
  sales_price: PropTypes.number,
  showLowQuantity: PropTypes.bool,
  tags: PropTypes.array,
  tasting_notes: PropTypes.arrayOf(PropTypes.string),
  terpenes: PropTypes.arrayOf(PropTypes.exact({
    id: PropTypes.string,
    name: PropTypes.string,
  })),
  unit_price: PropTypes.number,
  uri_param: PropTypes.string,
  variation: PropTypes.string,
  variation_type: PropTypes.string,
  product_id: PropTypes.string,
  single_price: PropTypes.number,
  total_grams: PropTypes.number,
  unit: PropTypes.string,
  updated_at: PropTypes.string,
});

export const cartItemsPT = PropTypes.arrayOf(PropTypes.exact({
  app_user_guid: PropTypes.string,
  app_user_id: PropTypes.string,
  cost: PropTypes.number,
  created_at: PropTypes.string,
  discount_cost: PropTypes.number,
  give_away: PropTypes.bool,
  id: PropTypes.string,
  product: productPT,
  product_id: PropTypes.string,
  quantity: PropTypes.string,
  single_price: PropTypes.number,
  total_grams: PropTypes.number,
  unit: PropTypes.string,
  updated_at: PropTypes.string,
}));

export const cartPT = PropTypes.exact({
  cartItems: cartItemsPT,
  costs: PropTypes.shape({
    subtotal: PropTypes.string,
  }),
  error_messages:  PropTypes.object,
  eta: PropTypes.string,
});
